import { useEffect, useState, useMemo } from "react";
import { Snowflake as SnowflakeIcon } from "lucide-react";

interface Snowflake {
  id: number;
  left: number;
  animationDuration: number;
  animationDelay: number;
  size: number;
  opacity: number;
}

export const Snowfall = () => {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    // Check if mobile on mount
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Pre-calculate snowflakes once based on device type
  const snowflakes = useMemo(() => {
    const count = isMobile ? 15 : 35; // Reduced count on mobile
    return Array.from({ length: count }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      animationDuration: 10 + Math.random() * 15,
      animationDelay: Math.random() * 10,
      size: isMobile ? 10 + Math.random() * 14 : 12 + Math.random() * 20, // Smaller on mobile
      opacity: 0.2 + Math.random() * 0.4,
    }));
  }, [isMobile]);

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className="snowflake"
          style={{
            left: `${flake.left}%`,
            animationDuration: `${flake.animationDuration}s`,
            animationDelay: `${flake.animationDelay}s`,
            opacity: flake.opacity,
            contain: "layout style paint",
            willChange: "transform",
          }}
        >
          <SnowflakeIcon 
            style={{ width: flake.size, height: flake.size }} 
            strokeWidth={1.5}
          />
        </div>
      ))}
    </div>
  );
};
